import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuController, ModalController } from '@ionic/angular';
import { AccountService } from 'src/app/services/account.service';
import { PlanService } from 'src/app/services/plan.service';

import { DocumentUploadModalComponent } from '../document-upload-modal/document-upload-modal.component';
@Component({
  selector: 'app-upload-doc',
  templateUrl: './upload-doc.component.html',
  styleUrls: ['./upload-doc.component.scss']
})
export class UploadDocComponent implements OnInit {
  additionalDocuments=[{name:'SALARY_CERTIFICATE',
  description:'SALARY_CERTIFICATE_DES',
   uploaded:false,
   front:null,
   back:null,
   docName:'',
   error:false,
  
 },
 {name:'OWNERSHIP', description:'Lrem epsum afd', uploaded:false, front:null,
  back:null,  docName:'', error:false},
  {name:'LABOUR_CONTRACT', description:'Lrem epsum afd', uploaded:false, front:null,
  back:null,  docName:'', error:false},
  {name:'BANK_STATEMENT', description:'Lrem epsum afd', uploaded:false, front:null,
  back:null,  docName:'',error:false},
  {name:'UTILITY_BILL', description:'Lrem epsum afd', uploaded:false, front:null,
  back:null,  docName:'',error:false},

]
 expiryDate:any;
 eid:any;
 loading=false;
 uploadedEid={front:null, back:null, eid:null, expiryDate:null};
 ocrScanSuccess=false;
//  currentAccount:any;
 changePlanId:any;
 documentCodes=[{name:'Ministry Lobour Contract',shortCode:'MLC'},
 {name:'Salary Certificate',shortCode:'SCR'},
 {name:'Bank Statement',shortCode:'BST'},
 {name:'Utility Bill',shortCode:'UTL'},
 {name:'Tenancy / Ownership contract',shortCode:'TOC'}]
 isHomeBound: any;
 agreedOnterms: any;
 sku: any;
 public isExpended: Boolean = false;
  constructor(private modalController: ModalController, private cdr: ChangeDetectorRef, private AS: AccountService,
    private activatedRoute:ActivatedRoute,
    private PS : PlanService,
    public router: Router

    ) { }

  ngOnInit( ): void {
    this.activatedRoute.queryParams.subscribe(res=>{
      if(res?.changePlanId){
        this.changePlanId= res?.changePlanId;
      }
    });
   // this.loadAdditionalDocuments();
  //  this.getAccount();
  }
  delete()
  {
    this.ocrScanSuccess=false;
    this.expiryDate='';
    this.eid='';
    this.uploadedEid={front:null, back:null, eid:null,expiryDate:null};
   
  }
  // loadAdditionalDocuments()
  // {

  
  // }

  openUploadDoc(type,index,edit)
  {
    setTimeout(() => {
      if(edit==true){
        if(type=='popUp')
        {
          this.openBottomSheet(DocumentUploadModalComponent,{type:type,index:index, file:this.uploadedEid, edit:true});
        }
      else{
        this.openBottomSheet(DocumentUploadModalComponent,{type:type,index:index,
           file:{front:this.additionalDocuments[index].front, back:this.additionalDocuments[index].back}, edit:true});
      }

    }
    else{
      this.openBottomSheet(DocumentUploadModalComponent,{type:type,index:index, edit:false});
    }
        
    }, 500);
  }
  async openBottomSheet(component: any, data?: any,classes='verification-modal modal-fullscreen') {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      backdropDismiss:false,
      cssClass: classes,
    });
    modal.onDidDismiss().then((x:any)=>{
     if(x.data?.success)
     {
       this.ocrScanSuccess=true;
      this.eid=x.data.eid;
      this.expiryDate=x.data.expiryDate;
      this.uploadedEid={front:x.data.front, back:x.data.back, eid:this.eid, expiryDate:this.expiryDate};
     }
     if(x.data?.uploaded==true)
     {
     // this.additionalDocuments[x.data.index].name=x?.data?.front?.name;
      this.additionalDocuments[x.data.index].docName=x?.data?.front?.name;
      this.additionalDocuments[x.data.index].uploaded=true;
      this.additionalDocuments[x.data.index].front=x.data.front;
      this.additionalDocuments[x.data.index].back=x.data.back;
      if(this.additionalDocuments[x.data.index].front.size>2097152)
      {
        this.additionalDocuments[x.data.index].error=true;
      }else{
        this.additionalDocuments[x.data.index].error=false;
      }
      //this.uploadedEid={front:x.data.front, back:x.data.back};
     
     }
     this.cdr.detectChanges();
      })
    return await modal.present();
  }
  edit()
  {
    //this.expiryDate='';
    //this.eid='';
  }
  deleteDoc(index)
  {
    this.additionalDocuments[index].uploaded=false;
    this.additionalDocuments[index].error=false;
  }
  check()
  {
    if(this.ocrScanSuccess&&this.additionalDocuments.filter(x=>x.uploaded==true).length>0&&this.loading==false)
    {
     return false;
    }
    return true;
  }
  submit()
  {
    this.loading=true;
    let  changePlan : any = {
      "changePlanId": this.changePlanId,
        documents:[{
         type: 'EID',
         docBase64: this.uploadedEid.front.base64File,
         name: 'UAE Identity card',
         docValidFrom:'',
         docValidTill:this.expiryDate,
         documentNumber:this.eid,
         format:this.uploadedEid.front.type
        }]
      }
    
    this.additionalDocuments.forEach(x=>{
      if(x.uploaded)
      {
        let arr=this.documentCodes.filter(y=>y.name==x.name)[0];
        let type=arr!=null?arr.shortCode:'';
        changePlan.documents.push(
          {
          type: type || '',
          docBase64: x.front.base64File,
          name: x.name,
          docValidFrom:'',
          docValidTill:'',
          documentNumber:'',
          format: x.front?.type
          
         })
      }
    
    })
//'bff92752-b720-41ea-b696-78091141b361'
   this.PS.changePlanUploadDocument(changePlan).subscribe(res=>{
     this.loading=false;
        //on success of service call 
    this.router.navigate(['billing'], {queryParams: {changePlanId:this.changePlanId,from:'PRECONTROLLINE'}});

   }, (error)=>{
     this.loading=false;
   })



  }

  

  // getAccount() {
  //   this.AS.getAllAccount().subscribe((resp) => {
  //     if (resp && resp.userAccounts && resp.userAccounts.length > 0) {
  //       this.currentAccount = resp.userAccounts[0];
  //       if(this.currentAccount){
  //        if (localStorage.getItem('currentAccount')) {
  //          const currentAccount = JSON.parse(localStorage.getItem('currentAccount'));
  //          this.currentAccount = currentAccount;
  //         }
  //       }
  //     }
  //    });
  //  }


}
